import React from 'react';
import { Linkedin, Instagram, Facebook } from 'lucide-react';
import CTABanner from '../../components/landingPage/CTABanner';
import SocialMediaCTA from '../../components/SocialMediaCTA';
import NewsSection from '../../components/landingPage/NewsSection';

const NewsHqProjectPage = () => {
  return (
    <div className="rk-page">
      {/* NewsHqProjectPage Hero Section-01 */}
      <section className="relative h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-[64vh] bg-cover bg-center" style={{ backgroundImage: "url('/hero_img/image-01.jpg')" }}>
        <div className="absolute top-0 left-0 w-full h-full bg-black/70 flex items-center justify-center">
          <h1 className=" text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center drop-shadow-lg font-poppins mx-auto w-11/12 md:w-3/4 lg:w-2/3">
            NEWS -Regional HQ Project
          </h1>
        </div>
        {/* Social Media Icons */}
        <div className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 flex flex-col space-y-2 sm:space-y-4 ">
          <a href="#" className="text-[#ECEE07] hover:text-white transition-colors duration-300">
            <Linkedin size={20} />
          </a>
          <a href="#" className="text-[#ECEE07] hover:text-white transition-colors duration-300">
            <Instagram size={20} />
          </a>
          <a href="#" className="text-[#ECEE07] hover:text-white transition-colors duration-300">
            <Facebook size={20} />
          </a>
        </div>
      </section>

      {/* DetailCard Section */}
      <section className="relative z-10 -mt-16 sm:-mt-20 mx-auto w-11/12 md:w-3/4 lg:w-2/3 bg-white p-6 sm:p-8 md:p-12 shadow-lg rounded-lg">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-[#364A9A] font-poppins">
          MK Metal Delivers Structural Foundation for Iconic Regional HQ Project
        </h2>
        <p className="mb-3 sm:mb-4 text-gray-700 font-gilda-display text-sm sm:text-base">
          In a monumental undertaking, MK Metal & Engineering Works successfully completed the structural foundation for the new Regional Headquarters. This project demanded precision engineering and robust solutions, showcasing our unparalleled expertise in large-scale steel construction. Our team meticulously planned and executed every phase, ensuring the highest standards of safety and structural integrity.
        </p>
        <p className="mb-3 sm:mb-4 text-gray-700 font-gilda-display text-sm sm:text-base">
          Utilizing <span className="text-[#364A9A] font-bold">advanced welding techniques</span> and <span className="text-[#364A9A] font-bold">certified materials</span>, we erected a framework designed to withstand significant environmental stresses and provide a lasting legacy. The innovative design required bespoke fabrication and on-site adjustments, all handled with our signature efficiency and technical prowess.
        </p>
        <p className="mb-3 sm:mb-4 text-gray-700 font-gilda-display text-sm sm:text-base">
          Our commitment to excellence was evident in the seamless integration of complex structural elements, delivered ahead of schedule and within budget. This significant achievement reinforces MK Metal's position as a leader in providing comprehensive structural steel solutions for ambitious architectural visions.
        </p>
        <p className="text-gray-700 font-gilda-display text-sm sm:text-base">
          The successful completion of this project is a testament to our dedicated workforce, cutting-edge technology, and unwavering focus on client satisfaction. We are proud to have contributed to a structure that will stand as a symbol of regional progress and innovation.
        </p>
      </section>
      <CTABanner className="my-12" />
      <SocialMediaCTA className="my-12" />
      <NewsSection className="my-12" />
    </div>
  );
};

export default NewsHqProjectPage;
